import LandingFixedButton from "@/components/common/LandingFixedButton";
import { useViewpostTopObserver } from "@/hooks/useViewpostTopObserver";
import { Stack } from "@chakra-ui/react";
import { colors, responsive, VStack } from "goi_common";

import GuideContent from "./components/Guide/GuideContent";

import GuideHead from "./components/Guide/GuideHead";
import GuideSummary from "./components/Guide/GuideSummary";

export default function Feed100SangjoContainer({ href }: { href?: string }) {
  const { viewportTopRef } = useViewpostTopObserver();
  const feed = {
    path: "100sangjo",
    date: "24-07-31",
    title: "100원 상조가 세상에 나온 이유",
    description:
      "100원으로 할 수 있는 게 많지 않은 세상입니다. 물 한 잔 사 먹기도 힘든 돈이지만 고이는 이 100원에 누군가의 마지막을 말하려 하는데요. 출시하자마자 CAC 관점에서 경쟁사 대비 50배 넘는 성과로 신호탄을 쏘아 올린 100원 상조. 이 요상한(?) 생각은 어떻게 시작된 것인지, 또 어떻게 이 시장을 바꿔 나갈 건지에 대해 공유드리고 싶습니다.",
    imgSrc: "direct/content/sn/2-3.png",
    keyword: "상조, 장례, 100원 상조",
    summary: {
      title: "아래에 해당하시면 도움 될 거예요 (2분)",
      description: [
        "👨🏻‍🦱: 고이는 왜 100원 상조를 만들었을까?",
        "👩🏻: 어떻게 100원으로 상조 운영이 가능할까?",
      ],
    },
    contents: [
      {
        type: "p",
        resource: " ",
      },
      {
        type: "h2",
        resource: "고작 100원으로 뭘 할 수 있겠냐구요?",
      },
      {
        type: "p",
        resource:
          "100원으로 할 수 있는 게 많지 않은 세상입니다. 물 한 잔 사 먹기도 힘든 돈이지만 고이는 이 100원에 누군가의 마지막을 말하려 하는데요. 출시하자마자 CAC 관점에서 경쟁사 대비 50배 넘는 성과로 신호탄을 쏘아 올린 100원 상조. <b>이 요상한(?) 생각은 어떻게 시작된 것인지, 또 어떻게 이 시장을 바꿔 나갈 건지에 대해 공유드리고 싶습니다.</b>",
      },
      {
        type: "h3",
        resource: "1. 대체 가전제품이 상조랑 무슨 상관일까",
      },
      {
        type: "img",
        resource: "direct/home/about-pr-2.png",
        imgAlt: "가전제품과 상조",
      },
      {
        type: "p",
        resource:
          "<u>한 번 쯤 들어 보셨을 거예요. 상조 가입 시 가전 제품 증정, 크루즈 증정, 어쩌구 저쩌구 증정.</u> 당장 죽음을 생각하는 분들이 많지 않고, 미리 준비하려는 분들은 더더욱 없기에 혜택이라는 미끼를 앞세워 가입을 유도하는 건데요.",
      },
      {
        type: "p",
        resource:
          "문제는 <u>업체가 폐업할 경우 상조 납입금의 50% 밖에 보상받지 못하며, 나아가 중도 해지할 경우 남은 가전제품 가액에 대한 위약금/추심까지 발생</u>한다는 점이죠. 허울 좋은 혜택으로 가입을 유도하는 기존 시스템. <b>고이는 이 시스템에 대한 해결이 상조에 대한 부정적 인식을 바꾸고, 더 많은 분들에게 죽음에 대한 준비를 건강하게 시작하게 할 액션이라 생각했습니다.</b> 올해 성공한 Pre-A 25억 투자 유치와 함께 선불제 상조 산업에 진입할 수 있게 되었고, 본격적으로 무언가 해 볼 환경도 마련되었죠.",
      },
      {
        type: "h3",
        resource: "2. 그렇게 시작한 우리의 테스트",
      },
      {
        type: "img",
        resource: "direct/home/100won.png",
        imgAlt: "100원 상조",
      },
      {
        type: "p",
        resource:
          "가전 제품 같은 혜택을 걷어내고, 본질에 집중했습니다. 다음 세 가지 메세지를 효과적으로 고객에게 전달한다면 우리는 성공할 수 있을 거라 생각했습니다.",
      },
      {
        type: "h4",
        resource: "(1) 매달 의미 없이 나가는 3만 원, 100원으로 줄이기",
      },
      {
        type: "p",
        resource:
          "기존 선불제 상조는 평균 월 3만 원에서 6만 원 사이의 납입금이 필요해요. 큰 부담은 아닐 수 있지만 정확한 니즈가 없다면 불필요하게 느껴질 수 있는 금액이죠. 이 금액을 100원이라는 형식적 수준으로 인하시키면 더욱 많은 분들께 가입의 문턱을 낮추고, 가입으로 인한 혜택들을 다양하게 제공할 수 있을 것이라 생각했습니다. 아직 상조의 필요성이 충분히 인지되지 못한 때, 앞서 죽음을 준비하고 언제 찾아올지 모르는 삶의 끝을 고민하는 것에 중요하다는 걸 한 분이라도 더 알게 만들고 싶었달까요. 장례 발생 시까지 납부하고, 잔액은 장례식 이후 후불로 납부하는 구조라면 새로운 경험을 만들 수 있을 거라 생각했습니다.",
      },
      {
        type: "h4",
        resource: "(2) 너무 높은 상품 가격, 50% 낮추기",
      },
      {
        type: "p",
        resource:
          "바가지라는 말이 과장이 아닌 시장입니다. 고객 입장에서는 ‘선불제’라는 개념 하에 미리 돈을 냈는데 또 돈을 내야 하는 게 납득이 가지 않죠. 예상치 못했던 현장 추가 구매까지 더해지면 애도 보다는 장사에 가깝다는 인식을 받게 됩니다. 고이는 이를 위해서 절대적인 상품 자체의 거품을 걷어내는 게 무엇보다 중요하다 생각했고, IT 기술력을 고도화해 약 5~600만 원의 가격을 200만 원 대로 낮췄어요. 또한 품목별 정찰제를 도입하고, 세부 품목을 사용하지 않았을 때 100% 공제해 드리는 부분까지 더함으로써 합리성, 그리고 투명성을 높였습니다. 이런 경험이 축적되면, 고객들이 상조의 가치를 인지하고, 이 인지가 시장 전반에 새로운 인식을 더할 거라 생각했어요.",
      },
      {
        type: "h4",
        resource: "(3) 비용 오를 걱정 없이, 평생 가격 고정",
      },
      {
        type: "p",
        resource:
          "고이는 10년 후 가격을 보장해요. 통계청에서 발표한 연간 소비자 물가 상승률은 2.6%인데요, 이에 따라 계산하면 약 200만 원의 장례 비용 상승도 함께 예상돼요. 미래의 어느 순간 언제 닥칠지 모르는 장례를 최대한 합리적이고, 또 마음 부담 없이 치를 수 있도록 지금 가입 시 평생 동일 가격을 보장해 드리기로 했어요.",
      },
      {
        type: "p",
        resource: "\n",
      },
      {
        type: "img",
        resource: "platform/prepare/prepare-1-8.png",
        imgAlt: "100원 상조",
      },
      {
        type: "p",
        resource:
          "<b>본질을 잃지 않는 것, 고이 팀의 신조이자 앞으로도 잃지 않을 나침반이에요.</b> 가격을 파격적으로 낮췄지만 정성과 애도의 마음까지 낮추진 않았습니다. 오히려 기본의 관행이 부적절했고, 그렇게 높은 가격과 예치금 없이도 편안하고, 안전하며, 정성스레 치를 수 있는 게 장례라는 걸 시장에 증명해 보이고 싶었어요.",
      },
      {
        type: "p",
        resource:
          "이 증명이 조금씩 성과로 보여 기쁜 마음입니다. 앞으로 죽음에 대한 건강한 담론이 익숙해질 수도 있도록. 또 익숙함 속에 폭리가 걷혀질 수 있도록 만드는 과정에 기여하고 싶습니다. 이제 막 시작한 100원 상조, 앞으로도 본질에 집중하려고 합니다. 그래서 언제 돌아 봐도 감동적인, 또 오래 가는 여운으로 기억될 만한 장례를 선물하도록 하겠습니다. 감사합니다.",
      },
    ],
  };
  return (
    <VStack width="100%" alignItems="center">
      <div ref={viewportTopRef}></div>
      <GuideHead title={feed.title} date={""} imgSrc={feed.imgSrc} isFeed />
      <Stack
        maxWidth={`720px`}
        width="100%"
        css={responsive({
          gap: { base: "28px", md: "40px" },
          padding: { base: "0 0 160px", lg: "60px 0px 160px" },
        })}
      >
        {feed.summary && <GuideSummary summary={feed.summary} />}
        <GuideContent contents={feed.contents} isFeed />
      </Stack>
      <LandingFixedButton
        color={colors.brown650}
        text="고이와 함께 100원으로 장례 준비하기"
        href={href || "/"}
        eventPath="feed"
      />
    </VStack>
  );
}
